/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_DescriptionInputs */

const en_segment_event_group_description = /** @type {(inputs: Segment_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide the selected source Event Group into smaller Event Groups.`)
};

const fr_segment_event_group_description = /** @type {(inputs: Segment_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diviser le groupe d'evenements source en groupes d'evenements plus petits.`)
};

const de_segment_event_group_description = /** @type {(inputs: Segment_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen Sie die ausgewählte Quellereignisgruppe in kleinere Ereignisgruppen auf.`)
};

const it_segment_event_group_description = /** @type {(inputs: Segment_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividere il gruppo di eventi sorgente selezionato in gruppi di eventi più piccoli.`)
};

const ru_segment_event_group_description = /** @type {(inputs: Segment_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разделите выбранную исходную группу событий на более мелкие группы событий.`)
};

const es_segment_event_group_description = /** @type {(inputs: Segment_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida el grupo de eventos de origen seleccionado en grupos de eventos más pequeños.`)
};

const zh_cn2_segment_event_group_description = /** @type {(inputs: Segment_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将选定的源事件组拆分为更小的事件组。`)
};

const ja_segment_event_group_description = /** @type {(inputs: Segment_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したソース イベント グループを小さなイベント グループに分割します。`)
};

const hi_segment_event_group_description = /** @type {(inputs: Segment_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित स्रोत इवेंट समूह को छोटे-छोटे इवेंट समूहों में विभाजित करें।`)
};

const pt_pt2_segment_event_group_description = /** @type {(inputs: Segment_Event_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida o grupo de eventos de origem selecionado em grupos de eventos menores.`)
};

/**
* | output |
* | --- |
* | "Divide the selected source Event Group into smaller Event Groups." |
*
* @param {Segment_Event_Group_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_description = /** @type {((inputs?: Segment_Event_Group_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_description(inputs)
	if (locale === "de") return de_segment_event_group_description(inputs)
	if (locale === "it") return it_segment_event_group_description(inputs)
	if (locale === "ru") return ru_segment_event_group_description(inputs)
	if (locale === "es") return es_segment_event_group_description(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_description(inputs)
	if (locale === "ja") return ja_segment_event_group_description(inputs)
	if (locale === "hi") return hi_segment_event_group_description(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_description(inputs)
	return en_segment_event_group_description(inputs)
});